/**
 * Scroll Reveal — lightweight IntersectionObserver-based entrance animations.
 *
 * Usage in HTML:
 *   <div class="reveal reveal--up" data-reveal-delay="150">...</div>
 *
 * Variants (add alongside "reveal"):
 *   reveal--up      → fades in + rises from below
 *   reveal--left    → fades in + slides from left
 *   reveal--right   → fades in + slides from right
 *   reveal--scale   → fades in + scales up from slightly smaller
 *
 * data-reveal-delay="N"  → extra delay in ms before the transition fires (for stagger)
 */

(function () {
  if (window.__baiorScrollRevealBooted) return;
  window.__baiorScrollRevealBooted = true;

  const THRESHOLD = 0.15; // how much of the element must be visible before triggering

  function initReveal() {
    const elements = document.querySelectorAll('.reveal');
    if (!elements.length) return;

    // Apply initial delay from data attribute
    elements.forEach((el) => {
      const delay = el.dataset.revealDelay;
      if (delay) {
        el.style.transitionDelay = delay + 'ms';
      }
    });

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('revealed');
            // Clear stagger delay so :hover / :focus transitions are instant (no perceived lag)
            const delay = parseInt(entry.target.dataset.revealDelay || '0', 10);
            window.setTimeout(() => {
              entry.target.style.transitionDelay = '0ms';
            }, 720 + delay);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: THRESHOLD }
    );

    elements.forEach((el) => observer.observe(el));
  }

  const SECTION_THRESHOLD = 0.08;

  function initSectionReveal() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const main = document.getElementById('MainContent');
    if (!main) return;

    const sections = Array.from(main.querySelectorAll(':scope > .shopify-section'));
    if (!sections.length) return;

    if (window.Shopify && Shopify.designMode) {
      sections.forEach((section) => section.classList.add('is-revealed'));
      return;
    }

    sections[0]?.classList.add('is-revealed');

    sections.forEach((section) => {
      if (section.querySelector('.spsc-section, .ss-section')) {
        section.classList.add('is-revealed');
      }
    });

    const toObserve = sections.slice(1).filter(
      (section) => !section.querySelector('.spsc-section, .ss-section')
    );
    if (!toObserve.length) return;

    const sectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            sectionObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: SECTION_THRESHOLD, rootMargin: '0px 0px -6% 0px' }
    );

    toObserve.forEach((section) => sectionObserver.observe(section));
  }

  function boot() {
    initReveal();
    initSectionReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
